var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { About } from './components/About';
import { Button } from './components/Button';
import { Catalog } from './components/Catalog';
import { Footer } from './components/Footer';
import { Form } from './components/Form';
import { Links } from './components/Links';
import { Media } from './components/Media';
import { Social } from './components/Social';
import { SectionContainer } from './components/styles';
import { Welcome } from './components/Welcome';
import { AppProvider } from './contexts/App';
import { Container } from './styles';
var isRunningOnServer = function () {
    return typeof window === undefined;
};
var getSectionComponent = function (site, section) {
    if (!section.active) {
        return null;
    }
    switch (section.type) {
        case 'welcome':
            return (_jsx(Welcome, { section: section }, section.id));
        case 'about':
            return _jsx(About, { section: section }, section.id);
        case 'catalog':
            return (_jsx(Catalog, { section: section }, section.id));
        case 'links':
            return _jsx(Links, { section: section }, section.id);
        case 'social':
            return (_jsx(Social, { section: section }, section.id));
        case 'form':
            return _jsx(Form, { section: section }, section.id);
        case 'media':
            return _jsx(Media, { section: section }, section.id);
        case 'button':
            return (_jsx(Button, { section: section }, section.id));
        default:
            null;
    }
};
export var SitePage = function (_a) {
    var site = _a.site, contextProps = _a.contextProps, theme = _a.theme, layout = _a.layout;
    var callPageLoad = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!contextProps.pageLoadLink) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(contextProps.pageLoadLink, { method: 'GET' })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [contextProps]);
    useEffect(function () {
        if (!isRunningOnServer()) {
            callPageLoad();
        }
    }, [callPageLoad]);
    return (_jsx(AppProvider, __assign({ value: { site: site, contextProps: contextProps } }, { children: _jsx(StyledThemeProvider, __assign({ theme: __assign(__assign({}, theme), layout) }, { children: _jsxs(Container, __assign({ backgroundColor: theme.primary, textColor: theme.secondary, "$layout": layout }, { children: [site.sections.map(function (section) {
                        return getSectionComponent(site, section);
                    }), _jsx(SectionContainer, { children: _jsx(Footer, {}, void 0) }, void 0)] }), void 0) }), void 0) }), void 0));
};
export { Player } from './components/Media/components/Player';
export { BehanceIcon } from './components/Social/icons/Behance';
export { FacebookIcon } from './components/Social/icons/Facebook';
export { InstagramIcon } from './components/Social/icons/Instagram';
export { TwitterIcon } from './components/Social/icons/Twitter';
export { YoutubeIcon } from './components/Social/icons/Youtube';
export { LinkedinIcon } from './components/Social/icons/Linkedin';
export { WhatsappIcon } from './components/Social/icons/Whatsapp';
export { DribbbleIcon } from './components/Social/icons/Dribbble';
export { MediumIcon } from './components/Social/icons/Medium';
export { TwitchIcon } from './components/Social/icons/Twitch';
export { TiktokIcon } from './components/Social/icons/Tiktok';
export { VimeoIcon } from './components/Social/icons/Vimeo';
